class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=10&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }
      
      var swiper = new Swiper(".search-drawer-slider.swiper", {
        slidesPerView: "auto",
        loop:true,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.3,
          momentumVelocityRatio: 0.3,
        },
        speed: 1000,
      });

        if (window.innerWidth > 1024) {
          document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function(element) {
            element.addEventListener('click', function(event) {
              event.preventDefault();
              var attVal = this.getAttribute('data-id');
              var productItem = this.closest('.product-item');
              var innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
              innerGrids.forEach(function(innerGrid) {
                if (attVal === innerGrid.getAttribute('data-id')) {
                  innerGrids.forEach(function(g) {
                    g.classList.remove('active');
                  });
                  innerGrid.classList.add('active');
                }
              });
            });
          });
          }

      
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click', function(e){
    document.body.classList.toggle('open-menu');
    const activeLi = document.querySelector('.mobile-nav > li.active');
    if (activeLi) {
      activeLi.classList.remove('active');
    }
    document.body.classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});

document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    setTimeout(function() {
      // document.querySelector(".main-search-bar #Search").focus();
      document.querySelector("#search-input").focus();
    }, 200);
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu,open-filter');
});
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
    
                document.querySelectorAll('.cart-count').forEach(function(el) {
  el.innerHTML = cart_count;
});
          
              // if(cart_count>0){
              //   document.querySelector('.cart-count').innerHTML = cart_count;
              // }else{
              //   document.querySelector('.cart-count').innerHTML = '';
              // }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
    });
  });
}
if (window.innerWidth > 1024) {
   if(document.querySelector('.list-menu')){
    document.querySelectorAll('.list-menu > li').forEach(function(navList){
      navList.addEventListener('mouseover', function(){
        navList.classList.add('active');
      });
      navList.addEventListener('mouseout', function(){
        navList.classList.remove('active');
      });
    });
  }
}

document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search','open-size-chart','open-find-store');
  }
};


// HEADER JS
var lastScroll = 0;
window.addEventListener('scroll', () => {
  let scrollCount = window.pageYOffset;
  if (scrollCount > 300) {
    document.body.classList.add('scroll-active');
    setTimeout(function () {
      if (scrollCount > lastScroll) {
        document.body.classList.remove('scroll-up');
        document.body.classList.add('scroll-down');
      } else if (scrollCount < lastScroll) {
        document.body.classList.remove('scroll-down');
        document.body.classList.add('scroll-up');
      }
      lastScroll = scrollCount;
    }, 0);
  } else {
    document.body.classList.remove('scroll-active', 'scroll-up', 'scroll-down');
    lastScroll = scrollCount;
  }
});

if (window.innerWidth < 1025) {
document.addEventListener("click", function (event) {
  if (event.target.closest(".close-search-btn")) {
    document.getElementById('search-input').value = '';
    document.querySelector('body').classList.remove("open-search");
    const predictiveSearch = document.getElementById("predictive-search");
    document.querySelectorAll('.searchlist').forEach(el => {
      el.classList.remove('active');
    });
    if (predictiveSearch) {
      predictiveSearch.style.display = "none";
    }
    const searchInput = document.getElementById("Search");
    if (searchInput) {
      searchInput.value = "";
    }
  }
});
}

// if (window.innerWidth > 1024) {
//   window.addEventListener("scroll", function () {
//     if (document.body.classList.contains("open-search")) {
//       document.body.classList.remove("open-search");
//       const predictiveSearch = document.getElementById("predictive-search");
//       if (predictiveSearch) {
//         predictiveSearch.style.display = "none";
//       }
//       const searchInput = document.getElementById("Search");
//       if (searchInput) {
//         searchInput.value = "";
//       }
//     }
//   });
// }


// wishlist click
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return; // exit if not clicked on a wishlist button
  const grid = btn.closest('.snippet-product-grid');
  if (grid) {
    grid.classList.add('open-wishlist');
  }
  btn.textContent = 'Select Size for Wishlist';
});

document.addEventListener('mouseout', function (e) {
  const grid = e.target.closest('.snippet-product-grid');
  if (!grid) return;

  // Only trigger when the mouse actually leaves the grid
  if (!grid.contains(e.relatedTarget)) {
    if (grid.classList.contains('open-wishlist')) {
      grid.classList.remove('open-wishlist');
      grid.querySelectorAll('.wishlist-btn').forEach(btn => {
        btn.textContent = 'Add to wishlist';
      });
    }
  }
});

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.wishlist-bar li.btn-link');
  if (!btn) return;

  debugger;
  const dataId = btn.getAttribute('data-id');
  if (!dataId) return;

  const productItem = btn.closest('.snippet-product-grid .inner-product-grid.active');
  if (!productItem) return;

  const wlButton = productItem.querySelector('.th_wl_col_btn');
  if (!wlButton) return;

  wlButton.setAttribute('data-variant_id', dataId);
  const wlProduct = wlButton.getAttribute('data-product_id');
  document.querySelector(`.th_wl_col_btn[data-product_id="${wlProduct}"] .wc_wishlistBlock`).click();
  // if (typeof wcPacificWishlistWidget === 'function') {
  //   wcPacificWishlistWidget('.th_wl_col_btn', wlProduct, 'collection');
  // }
  // await new Promise(resolve => setTimeout(resolve, 100));
  // const targetSelector = `.th_wl_col_btn[data-product_id="${wlProduct}"][data-variant_id="${dataId}"] .wc_wishlistBlock`;
  // const targetBtn = document.querySelector(targetSelector);
  // const targetBtn = wlButton.querySelector('.wc_wishlistBlock');
  // if (targetBtn) {
  //   targetBtn.click();
  //   productItem.querySelectorAll('.wishlist-btn').forEach(btn => {
  //     btn.textContent = 'Added to wishlist';
  //   });
  //   productItem.classList.add('wishlist-added');
  // } else {
  //   console.warn('⚠️ Wishlist block not found for selector:', targetSelector);
  // }
});